import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Header } from '../../../components';

function EmailStep({ email, setEmail }) {
  const location = useLocation();
  const history = useHistory()

  useEffect(() => {
    setEmail('');
  }, []);

  return (
    <section className="step-container">
      <Header goBack={() => history.goBack()} />
      <h1 className="step-title">
        { location?.state?.previousPath === '/orders'
          ? 'Bem-vinda(o) de volta! Faça login para ver seus pedidos'
          : 'Por qual e-mail o produtor pode falar com você?' }
      </h1>

      <div className="step-input-group">
        <div className="floating-label-input">
          <input required placeholder="E-mail" id="email" type="e-mail" name="email" value={email} onChange={(e) => setEmail(e.target.value.toLowerCase().trim())} />
          <label htmlFor="email">E-mail</label>
        </div>
      </div>
    </section>
  );
}

export default EmailStep;
